import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import type { FaqItem } from '../types';

interface Props {
  faq: FaqItem;
  index: number;
}

export const SortableFaqItem: React.FC<Props> = ({ faq, index }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: faq.id,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <tr ref={setNodeRef} style={style} className="hover:bg-slate-50">
      <td className="w-8 px-2 py-4">
        <button
          {...attributes}
          {...listeners}
          className="cursor-grab touch-none rounded p-1 text-slate-400 hover:bg-slate-100 hover:text-slate-600 active:cursor-grabbing"
          title="ドラッグして並び替え"
        >
          <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 24 24">
            <path d="M3 15h18v-2H3v2zm0 4h18v-2H3v2zm0-8h18V9H3v2zm0-6v2h18V5H3z" />
          </svg>
        </button>
      </td>
      <td className="px-4 py-4 text-sm text-slate-400">{index + 1}</td>
      <td className="px-4 py-4 text-sm font-medium text-slate-900">
        <span className="line-clamp-2">{faq.question}</span>
      </td>
      <td className="px-4 py-4 text-sm text-slate-600">
        <span className="line-clamp-2">
          {faq.answer.length > 60 ? `${faq.answer.slice(0, 60)}...` : faq.answer}
        </span>
      </td>
    </tr>
  );
};
